import Vue from "vue";
import Router from "vue-router";
import LayoutUser from "@/layouts/LayoutUser";

Vue.use(Router);

const router = new Router({
  mode: "history", // Use browser history
  linkActiveClass: "active",
  routes: [
    {
      path: "/",
      name: "SignIn",
      component: () => import("./components/SignIn"),
      meta: {
        skipAuth: true
      }
    },
    {
      path: "/dashboard",
      name: "Dashboard",
      component: () => import("./components/Dashboard"),
      props: true,
      meta: {
        layout: LayoutUser
      }
    },
    {
      path: "/signin",
      name: "SignIn",
      component: () => import("./components/SignIn"),
      meta: {
        skipAuth: true
      }
    },
    {
      path: "/signin-oidc",
      name: "SigninOidc",
      component: () => import("./components/SignInOidc"),
      meta: {
        skipAuth: true
      }
    }
  ]
});

export default router;
